import React from 'react';
import { SectionCard, TextField, TextAreaField, NumberField, Repeater, SwitchField } from '../../../components/admin/EditorFields';

const ICONS = ['Heart', 'Droplet', 'Sparkles', 'Award', 'Receipt', 'Shield', 'Users', 'Gift'];

export default function DonateEditor({ data, setData }) {
  const upd = (path, value) => setData((d) => {
    const next = JSON.parse(JSON.stringify(d));
    const keys = path.split('.');
    let cur = next;
    for (let i = 0; i < keys.length - 1; i++) {
      cur[keys[i]] = cur[keys[i]] || {};
      cur = cur[keys[i]];
    }
    cur[keys[keys.length - 1]] = value;
    return next;
  });

  return (
    <div className="space-y-5">
      <SectionCard title="En-tête de la page">
        <TextField label="Badge (en haut)" value={data.hero?.badge} onChange={(v) => upd('hero.badge', v)} />
        <div className="grid sm:grid-cols-2 gap-3">
          <TextField label="Titre" value={data.hero?.title} onChange={(v) => upd('hero.title', v)} />
          <TextField label="Titre en couleur" value={data.hero?.titleHighlight} onChange={(v) => upd('hero.titleHighlight', v)} />
        </div>
        <TextAreaField label="Description" rows={3} value={data.hero?.description} onChange={(v) => upd('hero.description', v)} />
      </SectionCard>

      <SectionCard title="Paliers de don" description="4 paliers recommandés. Marquez un palier comme populaire pour le mettre en avant.">
        <Repeater
          items={data.tiers}
          onChange={(items) => setData((d) => ({ ...d, tiers: items }))}
          newItem={() => ({ amount: 50, label: '', impact: '', icon: 'Heart', popular: false })}
          addLabel="Ajouter un palier"
          renderItem={(item, update) => (
            <div className="space-y-3">
              <div className="grid sm:grid-cols-3 gap-3">
                <NumberField label="Montant (€)" value={item.amount} onChange={(v) => update({ amount: v })} />
                <TextField label="Libellé" value={item.label} onChange={(v) => update({ label: v })} />
                <div>
                  <label className="text-xs font-semibold uppercase tracking-wider text-slate-600 mb-1.5 block">Icône</label>
                  <select value={item.icon || 'Heart'} onChange={(e) => update({ icon: e.target.value })} className="w-full h-11 rounded-xl border border-sky-200 px-3 text-sm">
                    {ICONS.map((i) => <option key={i} value={i}>{i}</option>)}
                  </select>
                </div>
              </div>
              <TextField label="Impact (description)" value={item.impact} onChange={(v) => update({ impact: v })} />
              <SwitchField label="Marquer comme populaire" hint="Affiche un badge mis en avant." value={item.popular} onChange={(v) => update({ popular: v })} />
            </div>
          )}
        />
      </SectionCard>

      <SectionCard title="Bloc « Pourquoi nous faire confiance ? »">
        <Repeater
          items={data.trust}
          onChange={(items) => setData((d) => ({ ...d, trust: items }))}
          newItem={() => ({ icon: 'Shield', text: '' })}
          renderItem={(item, update) => (
            <div className="grid sm:grid-cols-2 gap-3">
              <div>
                <label className="text-xs font-semibold uppercase tracking-wider text-slate-600 mb-1.5 block">Icône</label>
                <select value={item.icon || 'Shield'} onChange={(e) => update({ icon: e.target.value })} className="w-full h-11 rounded-xl border border-sky-200 px-3 text-sm">
                  {ICONS.map((i) => <option key={i} value={i}>{i}</option>)}
                </select>
              </div>
              <TextField label="Texte" value={item.text} onChange={(v) => update({ text: v })} />
            </div>
          )}
        />
      </SectionCard>

      <SectionCard title="FAQ">
        <Repeater
          items={data.faqs}
          onChange={(items) => setData((d) => ({ ...d, faqs: items }))}
          newItem={() => ({ q: '', a: '' })}
          addLabel="Ajouter une question"
          renderItem={(item, update) => (
            <div className="space-y-3">
              <TextField label="Question" value={item.q} onChange={(v) => update({ q: v })} />
              <TextAreaField label="Réponse" rows={3} value={item.a} onChange={(v) => update({ a: v })} />
            </div>
          )}
        />
      </SectionCard>
    </div>
  );
}
